import { MergeDocumentsCrmo } from 'domain/usecases/surgical-order/merge-documents-crmo'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteMergeDocumentsCrmo implements MergeDocumentsCrmo {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  merge(params: MergeDocumentsCrmo.Params): Promise<MergeDocumentsCrmo.Model> {
    return this.surgicalOrderRepository.mergeDocumentsCrmo(params)
  }
}
